import { c as createCommonjsModule, a as commonjsGlobal } from './common/_commonjsHelpers-8c19dec8.js';
import { r as react } from './common/index-0a062023.js';

var distWeb = createCommonjsModule(function (module, exports) {
var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (commonjsGlobal && commonjsGlobal.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (commonjsGlobal && commonjsGlobal.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAsyncStatus = exports.AsyncStates = void 0;
var React = __importStar(react);
var AsyncStates;
(function (AsyncStates) {
    AsyncStates["Idle"] = "Idle";
    AsyncStates["Pending"] = "Pending";
    AsyncStates["Success"] = "Success";
    AsyncStates["Error"] = "Error";
})(AsyncStates = exports.AsyncStates || (exports.AsyncStates = {}));
function useAsyncStatus(asyncFn, deps, successTimeout // How long Success state is active until reverting to Idle
) {
    if (deps === void 0) { deps = []; }
    var _a = React.useState({
        status: AsyncStates.Idle,
        lastResult: null,
        lastError: null,
    }), _b = _a[0], status = _b.status, lastResult = _b.lastResult, lastError = _b.lastError, updateState = _a[1];
    // Thing that calls the async function
    var trigger = React.useCallback(function trigger() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return __awaiter(this, void 0, void 0, function () {
            var result_1, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        updateState(function (state) { return (__assign(__assign({}, state), { status: AsyncStates.Pending })); });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, asyncFn.apply(void 0, args)];
                    case 2:
                        result_1 = _a.sent();
                        updateState(function (state) { return (__assign(__assign({}, state), { status: AsyncStates.Success, lastResult: result_1 })); });
                        if (successTimeout !== undefined) {
                            // Reset to Idle state
                            setTimeout(function () {
                                updateState(function (state) { return (__assign(__assign({}, state), { status: AsyncStates.Idle })); });
                            }, successTimeout);
                        }
                        // Return the result of the async function
                        return [2 /*return*/, result_1];
                    case 3:
                        error_1 = _a.sent();
                        updateState(function (state) { return (__assign(__assign({}, state), { status: AsyncStates.Error, lastError: error_1 })); });
                        // Return the error
                        return [2 /*return*/, error_1];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }, __spreadArrays([successTimeout], deps));
    var reset = React.useCallback(function reset() {
        updateState(function (state) { return (__assign(__assign({}, state), { status: AsyncStates.Idle, lastResult: null, lastError: null })); });
    }, []);
    return { trigger: trigger, status: status, lastResult: lastResult, lastError: lastError, reset: reset };
}
exports.useAsyncStatus = useAsyncStatus;
});

var AsyncStates = distWeb.AsyncStates;
var useAsyncStatus = distWeb.useAsyncStatus;
export { AsyncStates, useAsyncStatus };
